import { createContext, useContext } from "react";

/**
 * Whether the window a body stands in has a frame on its page (ADR-061's amendment "every game window moves and
 * resizes", item 9): false where the room cannot hold the window's minimum, the narrow and phone layouts. A body outside
 * a framed window reads true, as a page that never narrows is.
 */
export const WindowFramedContext = createContext<boolean>(true);

/**
 * Whether the window this body stands in has a frame now, following the page as it resizes.
 *
 * @returns True where the window can be moved and resized; false in the narrow layout.
 */
export function useWindowFramed(): boolean {
  return useContext(WindowFramedContext);
}
